module.exports = __webpack_public_path__ + "img/web.1afb6220.svg";